import { RxEnrichmentAPI } from '@driftt/dapper'
import { fromJS } from 'immutable'

export const api = {
  fetchDemandbaseCompanyData(options = {}) {
    return RxEnrichmentAPI.get(`/enrichment/demandbase`, options)
      .checkStatus()
      .mapResponse(fromJS)
  },

  fetchDemandbaseIndustries() {
    return RxEnrichmentAPI.get(`/enrichment/demandbase/industries`)
      .checkStatus()
      .map(res => res.response)
  },

  fetchDemandbaseSubIndustries() {
    return RxEnrichmentAPI.get(`/enrichment/demandbase/sub_industries`)
      .checkStatus()
      .map(res => res.response)
  }
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/enrichment/demandbase/api.js